import React from 'react';
import Link from 'gatsby-link';
import Logo from '../logo/Logo';
import Services from '../Services';

const Footer = ({ }) => (
  <footer className="footer">
    <div className="top">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-sm-4">
            <Logo />
            <hr />
            <i>When performance counts!</i>
          </div>
          <div className="col-sm-4 align-self-center">
            <Services services={[
              { text: 'Web Design', icon: 'fa fa-diamond' },
              { text: 'Software Development', icon: 'fa fa-laptop' },
              { text: 'Geospatial Solutions', icon: 'fa fa-globe' }
            ]} />
          </div>
          <div className="col-sm-4 col-lg-3 align-self-center">
            <a href="https://github.com/rustygreen" target="_blank" className="social-share text-accent">
              <i className="fa fa-github-square"></i>
            </a>
            <a href="https://www.linkedin.com/in/rustymgreen/" target="_blank" className="social-share text-accent">
              <i className="fa fa-linkedin-square"></i>
            </a>
            <a href="https://plus.google.com/+RussellGreen" target="_blank" className="social-share text-accent">
              <i className="fa fa-google-plus-square"></i>
            </a>
            <a href="https://bitbucket.org/rustymgreen" target="_blank" className="social-share text-accent">
              <i className="fa fa-bitbucket-square"></i>
            </a>
            <br />
            <a href="mailto:rustymgreen@gmail.com?Subject=Contact%20from%20website" target="_top" className="text-secondary">
              <i className="fa fa-envelope-o" aria-hidden="true"></i> rusty@rustygreen.com
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="bottom">
      <div className="container text-center">
        <Link className="navbar-item" to="/">
          <i className="fa fa-home" aria-hidden="true"></i> Home
        </Link>
        <Link className="navbar-item" to="/resume">
          <i className="fa fa-file-text-o" aria-hidden="true"></i> Resume
        </Link>
        <Link className="navbar-item" to="/portfolio">
          <i className="fa fa-folder-open-o" aria-hidden="true"></i> Portfolio
        </Link>
        <Link className="navbar-item" to="/blog">
          <i className="fa fa-user-o" aria-hidden="true"></i> Blog
        </Link>
      </div>

      <div className="container text-center copyright">
        © Copyright {new Date().getFullYear()} {'Rusty' + ' ' + 'Green'}
      </div>

      <div className="container text-center legal">
        Website design by www.RustyGreen.com | Privacy Policy | Your Privacy Rights | Terms Of Use
      </div>
    </div>
  </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js